import { formatHumanName } from "@medplum/core";
import type { PractitionerDto } from "@repo/data-store";

/**
 * `formatHumanName` rather than a given+family join: a HumanName may carry only
 * `text`, which is what every seed-invited practitioner has, and joining parts
 * that aren't there rendered them blank or as "Unknown". The one formatter for
 * practitioner names, so a picker's selected value and its dropdown rows cannot
 * disagree about the same person. Undefined when there is nothing to show, so
 * each caller picks its own fallback.
 */
export function practitionerDisplayName(p: Pick<PractitionerDto, "name"> | null | undefined): string | undefined {
  return (p && formatHumanName(p.name).trim()) || undefined;
}

export function getPractitionerName(p: PractitionerDto): string {
  return practitionerDisplayName(p) ?? "Unknown";
}
